<template>
  <ai-button
    class="AiSkiplinks-item"
    :label="label"
    :url="anchor"
    :as-link="true"
    :light="inverse"
    small />
</template>

<script setup lang="ts">
type Props = {
  inverse?: boolean;
  label: string;
  anchor: string;
};
withDefaults(defineProps<Props>(), {
  label: undefined,
  anchor: undefined,
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/colors';

.AiSkiplinks-item {
  position: absolute;
  opacity: 0;
  top: 50%;
  left: constants.$margin-00;

  outline: none;

  &:focus-visible {
    opacity: 1;
    z-index: 999;
    transform: translateY(-50%);
  }

  &:focus::after {
    border-width: 1px;
    border-color: colors.$gold-900;
  }

  &.AiButton--light:focus::after {
    border-color: colors.$gold-300;
  }

  @media (mq.$from-medium) {
    top: 65%;
    left: 23rem;
  }
  @media (mq.$from-large) {
    left: 28rem;
  }
}
</style>
